const OPEN = String.fromCharCode(0xfdd0);
const CLOSE = String.fromCharCode(0xfdd1);
const PLACEHOLDER = new RegExp(`${OPEN}([0-9]{1,9})${CLOSE}`, 'g');
const MARKS = new RegExp(`[${OPEN}${CLOSE}]`, 'g');

/** Whether the text holds a placeholder mark, so part of it came from a source value. */
export const hasLiteralMark = (text: string): boolean => text.includes(OPEN) || text.includes(CLOSE);

/**
 * Expands the placeholders the server put where source text appeared (#1352). Apply it
 * after markdown parsing, to text children only, so a value can never become markup.
 * An index without a value, and a stray mark, expand to nothing.
 */
export const expandLiteralValues = (text: string, values?: unknown): string => {
  if (!hasLiteralMark(text)) return text;
  const known = Array.isArray(values) ? values : [];
  return text
    .replace(PLACEHOLDER, (_, index: string) => (Number(index) < known.length ? String(known[Number(index)]) : ''))
    .replace(MARKS, '');
};
